import { render, staticRenderFns } from "./NewEditSeriePage.vue?vue&type=template&id=be17beb0&scoped=true"
import script from "./NewEditSeriePage.vue?vue&type=script&lang=js"
export * from "./NewEditSeriePage.vue?vue&type=script&lang=js"
import style0 from "./NewEditSeriePage.vue?vue&type=style&index=0&id=be17beb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be17beb0",
  null
  
)

export default component.exports